import * as React from 'react';
import sanitizeHtml from 'sanitize-html';
import { useSettingsContext } from '../../contexts/settings';

const ProviderResource = ({ post }) => {
	const settings = useSettingsContext();

	const cardClass =
		'card-provider-resource' + (post.featured ? ' card-provider-resource-featured' : '');
	const wrapperClass = post.featured ? 'col-lg-6' : 'col-lg-4';

	return (
		<div className={wrapperClass}>
			<a href={post.permalink} className={cardClass}>
				{0 !== post.featured && (
					<span className="card-provider-resource-featured-featured">Featured</span>
				)}
				{!settings.hideImages && (
					<figure
						className="card-provider-resource__image"
						dangerouslySetInnerHTML={{ __html: post.featured_image }}
					/>
				)}
				<time>{post.type}</time>
				<h6 dangerouslySetInnerHTML={{ __html: sanitizeHtml(post.post_title) }} />
				<span>{post.cta}</span>
			</a>
		</div>
	);
};

ProviderResource.displayName = 'ProviderResource';

export default ProviderResource;
